export default __webpack_public_path__ + "static/media/rambouillet03.96a709be.jpg";